// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AppName_wrapper__kgHDV","appLogo":"AppName_appLogo__2OH_H","appName":"AppName_appName__3mGuI"};